/**
 * On-Pipe Equipment Configurator — Engineering sub-tab page.
 * Same layout pattern as EngineeringPage / HeatProfilePage (tabs left-aligned).
 */

import React from 'react';
import OnPipeConfiguratorPage from '../../components/OnPipeConfigurator/OnPipeConfiguratorPage';
import EngineeringSubTabs from './EngineeringSubTabs';
import '../technical/HeatProfilePage.css';

const OnPipeEngineeringPage = () => (
  <div className="heat-profile-page">
    <EngineeringSubTabs />
    <div className="heat-profile-content-wrapper">
      <OnPipeConfiguratorPage />
    </div>
  </div>
);

export default OnPipeEngineeringPage;
